<template>
  <div class="wrap">
    <div class="tabs" :class="{striped:striped}">
      <div class="child" v-for="(item,index) in tabsItems" :key="index" :class="{assertive:index==value[0]}"
           @click="itemClick(index)">
        <span v-if="item.icon" class="icon" :class="index==value[0]?item.iconActive:item.icon"></span>
        <span :class="{'van-hairline--left':lineBetween&&index!=0}">{{item.title}}
          <i class="icon icon-arrow-down" v-if="item.children"></i>
        </span>

      </div>
    </div>
    <van-popup v-model="show" position="top" transition="fade">
      <div class="padding">
        <Item class="van-hairline--bottom" :class="ceil.select?'select':''" v-for="(ceil,index) in children"
              :key="index" :title="ceil.title" :rightIcon="ceil.select?'icon-right':''" @click="subClick(index)"></Item>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import Item from '../item/'
import { Popup } from 'vant'

Vue.use(Popup)
export default {
  data () {
    return {
      show: false,
      children: []
    }
  },
  components: {
    Item
  },
  props: {
    tabsItems: {
      type: Array,
      default: []
    },
    striped: {
      type: Boolean,
      default: false
    },
    lineBetween: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: 0
    }
  },
  methods: {
    itemClick (e) {
      this.children = this.tabsItems[e].children
      let value = [e, this.value[1] ? this.value[1] : 0]
      if (this.children) {
        this.show = true
      } else {
        this.show = false
      }
      this.$emit('input', value)
      this.$emit('click', value)
      if (this.children) {
        this.setItem(value[1])
      }
    },
    setItem (index) {
      this.children = this.children.map((item, i) => {
        if (index === i) {
          item.select = true
        } else {
          item.select = false
        }
        return item
      })
    },
    subClick (index) {
      let value = [this.value[0], index]
      this.$emit('input', value)
      this.$emit('click', value)
      this.show = false
      this.setItem(index)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.tabs {
  display: flex;
  height: 50px;
  align-items: center;
  background: $light;
  border-top: 1px solid $gray;
  &.striped {
    align-items: stretch;
    .child {
      display: flex;
      justify-content: center;
    }
    .assertive {
      position: relative;
      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        height: 2px;
        width: 30px;
        background: $assertive;
        left: 50%;
        margin-left: -15px;
        border-radius: 1px;
      }
    }
  }
  .child {
    flex: 1;
    text-align: center;
    display: flex;
    flex-direction: column;
    color: $dark09;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    i {
      font-size: 12px;
    }

    span:nth-child(2) {
      font-size: 12px;
    }
    > .icon {
      font-size: 18px;
      padding-bottom: 2px;
    }
  }
}

.wrap {
  .padding {
    padding: 0 10px;
    /deep/ .item {
      padding: 15px 10px;
      min-height: 52px;
      &.select {
        color: $assertive;
        h3,
        p {
          color: $assertive;
        }
      }
    }
  }
  /deep/ .van-popup {
    top: auto;
    margin-top: 1px;
  }
  /deep/ .van-modal {
    top: auto;
    margin-top: 1px;
  }
}
</style>
